if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                if (!window.Shopify) window.Shopify = {};
                if (!window.Shopify.routes) {
                    window.Shopify.routes = { cart: window.routes?.cart_url || "/cart" };
                }
                if (!window.routes) window.routes = {};
                if (!window.routes.cart_add_url) {
                    window.routes.cart_add_url = "/cart/add";
                }

                this.form = this.querySelector("form");
                this.variantIdInput.disabled = false;
                this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
                this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
                this.submitButton = this.querySelector('[type="submit"]');
                this.submitButtonText = this.submitButton.querySelector("span");

                if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

                this.hideErrors = this.dataset.hideErrors === "true";
            }

            getSubscriptionAddonItems(mainVariantId) {
                const sellingPlanInput =
                    document.querySelector('input[name="selling_plan"]:checked') ||
                    document.querySelector('select[name="selling_plan"]');

                if (!sellingPlanInput?.value || sellingPlanInput.value === "onetime") return [];

                const addonEls = document.querySelectorAll(".subscription-addon-item[data-variant-id]");
                if (!addonEls.length) return [];

                return Array.from(addonEls).map((el) => ({
                    id: el.dataset.variantId,
                    quantity: 1,
                    properties: {
                        "Free Gift": "Offer",
                        _subscription_addon: "true",
                        _linked_to: mainVariantId,
                    },
                }));
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true") return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove("hidden");

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        "sections",
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append("sections_url", window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }

                const mainVariantId = formData.get("id");
                const giftItems = this.getSubscriptionAddonItems(mainVariantId);

                let fetchPromise;

                if (giftItems.length > 0) {
                    // ✅ Multi-item JSON path — main product + gifts in ONE request
                    const mainItem = {
                        id: parseInt(mainVariantId),
                        quantity: parseInt(formData.get("quantity") || 1),
                    };
                    const sellingPlan = formData.get("selling_plan");
                    if (sellingPlan) mainItem.selling_plan = parseInt(sellingPlan);

                    // ✅ FIX: sections must be a comma-separated STRING, not array
                    const sectionIds = this.cart
                        ? this.cart.getSectionsToRender().map((s) => s.id).join(",")
                        : "";

                    fetchPromise = fetch(`${window.routes.cart_add_url}.js`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                        },
                        body: JSON.stringify({
                            items: [mainItem, ...giftItems],
                            sections: sectionIds,
                            sections_url: window.location.pathname,
                        }),
                    }).then((r) => r.json());
                } else {
                    // ✅ Original FormData path — untouched for no-gift case
                    const config = fetchConfig("javascript");
                    config.headers["X-Requested-With"] = "XMLHttpRequest";
                    delete config.headers["Content-Type"];
                    config.body = formData;

                    fetchPromise = fetch(`${routes.cart_add_url}`, config).then((r) => r.json());
                }

                fetchPromise
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute("aria-disabled", true);
                            this.submitButtonText.classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        // ✅ FIX: Multi-item response returns { items: [...], sections: {...} }
                        // Normalize it so renderContents always gets { id, sections }
                        // ✅ AFTER — sections come back as-is from Shopify, pass them through directly
const normalizedResponse = giftItems.length > 0
    ? {
        id: response.items?.[0]?.id,
        sections: response.sections ?? null,
    }
    : response;


                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                cartData: normalizedResponse,
                            });
                        this.error = false;

                        const quickAddModal = this.closest("quick-add-modal");

                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(normalizedResponse);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(normalizedResponse);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty"))
                            this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading__spinner").classList.add("hidden");
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage =
                    this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

                this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }

            toggleSubmitButton(disable = true, text) {
                if (disable) {
                    this.submitButton.setAttribute("disabled", "disabled");
                    if (text) this.submitButtonText.textContent = text;
                } else {
                    this.submitButton.removeAttribute("disabled");
                    this.submitButtonText.textContent = window.variantStrings.addToCart;
                }
            }

            get variantIdInput() {
                return this.form.querySelector("[name=id]");
            }
        }
    );
}
